import React from "react";
import { Navigate } from "react-router-dom";

const LegacyServiceRedirect = () => <Navigate to="/" replace />;

export default LegacyServiceRedirect;
